import { FormEvent, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function SignupPage() {
  const { signup } = useAuth()
  const history = useHistory()
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await signup(email, password, displayName)
      history.push('/studio')
    } catch (err: any) {
      setError(err.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mx-auto max-w-sm px-4 py-12">
      <p className="spec-label mb-2">New operator registration</p>
      <h1 className="font-display text-3xl font-bold">Sign up</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        An account unlocks the Studio, where warm-ups are authored, tagged, and taken very seriously.
      </p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label htmlFor="displayName" className="spec-label">Name</label>
          <input
            id="displayName"
            type="text"
            required
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="mt-1 w-full rounded-md border bg-card px-3 py-2.5"
          />
        </div>
        <div>
          <label htmlFor="email" className="spec-label">Email</label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-md border bg-card px-3 py-2.5"
          />
        </div>
        <div>
          <label htmlFor="password" className="spec-label">Password</label>
          <input
            id="password"
            type="password"
            required
            minLength={10}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-md border bg-card px-3 py-2.5"
          />
          <p className="mt-1 text-xs text-muted-foreground">At least 10 characters. This is a serious appliance.</p>
        </div>

        {error && <p className="text-sm text-destructive">{error}</p>}

        <button
          type="submit"
          disabled={busy}
          className="w-full min-h-[48px] rounded-full bg-primary font-semibold text-primary-foreground disabled:opacity-60"
        >
          {busy ? 'Registering…' : 'Create account'}
        </button>
      </form>

      <p className="mt-6 text-sm text-muted-foreground">
        Already registered? <Link to="/login" className="underline">Log in</Link>.
      </p>
    </div>
  )
}
